<template>
  <div>
   
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Add Document</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br>
        <v-row justify="center">
          <!-- <v-autocomplete color="#0F2027" dense rounded required v-model="document_category" return-object
                            :items="document_category_list" item-text="name" label="Select Document Category" outlined @change="getStd()"
                            persistent-hint hint="Please Select Document Category " /> -->

          <v-col cols="12" sm="4">
            <v-autocomplete color="#0F2027" dense rounded required v-model="document_category" return-object
              :items="document_category_list" item-text="category_name" label="Select Document Category" outlined
              persistent-hint hint="Please Select Document Category" @change="get_document_sub_category()" />
          </v-col>
          <!-- @change="get_document_sub_category()" -->
          <div></div>
          <v-col cols="12" sm="4" v-if="document_sub_category_list != '' && document_category != ''">
            <v-autocomplete color="#0F2027" dense rounded required v-model="document_sub_category" return-object
              :items="document_sub_category_list" item-text="subcat_name" label="Select Document Sub Category" outlined
              persistent-hint hint="Please Select Document Sub Category" />
          </v-col>
        </v-row>
        <v-row justify="center" v-if="document_category != ''">
          <v-col cols="12" sm="4" style="margin-top: -25px;">
            <v-icon color="error">*</v-icon>
            <v-text-field rounded outlined dense type="text" label="Document Name" v-model="doc_name"
              width="50"></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" justify="center" align="center">
            <v-text-field rounded outlined dense type="text" label="Document Reference Number"
              v-model="reference_number"></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-value="id"
              item-text="ay" label="Select AY" outlined persistent-hint hint="Please Select AY" />
          </v-col>

        </v-row>
        <v-row justify="center" class="pa-40" v-if="document_category != ''">
          <v-col cols="12" sm="4">
            <v-text-field label="Validity From Date(inclusive)" rounded outlined dense type="date"
              v-model="fromdate"></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field label="Validity To Date(Exclusive)" rounded outlined dense type="date"
              v-model="todate"></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field label="Issue Date" rounded outlined dense type="date" v-model="issue_date"></v-text-field>
          </v-col>

        </v-row>
        <v-row justify="center" class="pa-40" v-if="document_category != ''">
          <v-col cols="12" sm="4" md="4" style="margin-top: -25px;">
            <v-icon color="error">*</v-icon>
            <v-file-input prepend-icon="mdi-paperclip" label="Attachment" show-size flat rounded outlined dense
              v-model="doc_file"></v-file-input>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field rounded outlined dense :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
              label="File Opening Password(If Any)" v-model="opening_password" @click:append="() => (value = !value)"
              :type="value ? 'password' : 'text'"></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field rounded outlined dense type="text" label="Keywords To Search File"
              v-model="keywords"></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" class="pa-40"
          v-if="document_category.category_name !== 'Office Order' && document_category != ''">
          <v-col cols="12" sm="4">
            <v-autocomplete color="#0F2027" dense rounded required v-model="assigned_to" :items="instructor_list"
              item-value="id" item-text="name" return-object label="Assigned To" outlined persistent-hint
              hint="Please Assigned To" @change="setvalues(assigned_to)" />
          </v-col>

          <v-col cols="12" sm="4">
            <v-autocomplete color="#0F2027" dense rounded required v-model="vendor" :items="vendor_list" item-value="id"
              item-text="company_name" label="Select Vendor" outlined persistent-hint hint="Please Select Vendor" />
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field rounded outlined dense type="text" label="Target Person"
              v-model="target_person_name"></v-text-field>
          </v-col>
        </v-row>

        <v-row class="pa-40" v-if="document_category != ''">
          <v-col cols="12" sm="4">
            <v-autocomplete color="#0F2027" dense rounded required v-model="document_level" :items="document_level_list"
              item-value="id" item-text="name" label="Document Level" outlined persistent-hint hint="Document Level" />
          </v-col>

          <v-col cols="12" sm="4" v-if="document_category.category_name === 'Office Order'">
            <v-autocomplete color="#0F2027" dense rounded required v-model="instructor" :items="instructor_list"
              item-text="name" return-object label="Please Select Instructor" outlined persistent-hint
              hint="Please Select Instructor" />
          </v-col>
          <v-col cols="12" sm="4" v-if="assigned_to && document_category.category_name !== 'Office Order'">
            <v-text-field rounded outlined dense type="text" label="Assigned Person Email"
              v-model="assigned_person_email"></v-text-field>
          </v-col>

          <v-col cols="12" sm="4" v-if="assigned_to && document_category.category_name !== 'Office Order'">
            <v-text-field rounded outlined dense type="text" label="Assigned Person Contact"
              v-model="assigned_person_contact"></v-text-field>
          </v-col>


        </v-row>

        <v-row justify="center" v-if="document_category != ''">
          <v-col cols="12" sm="4">
            <v-textarea outlined name="input-7-4" v-model="description" label="Enter Description"></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center" v-if="document_category != ''">
          <v-btn class="button" :loading="loader" @click="addDocument" dense>Save</v-btn>
        </v-row>
        <br>
      </v-card>

      <v-card class="box" v-if="documents_list != ''">
        <v-data-table :headers="headers" :items="documents_list">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Documents List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <!-- <div>kshitij</div> -->
          <template v-slot:[`item.attachment`]="{ item }">
            <span v-if="item.attachment != null">
              <!-- <a @click.prevent="promptPassword(item)">Attachment</a> -->
              <a target="_blank" :href="basepath + item.attachment">Attachment</a>
            </span>
            <span v-else>-</span>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-icon color="red" @click="deleteDocument(item.id)">mdi-trash-can</v-icon>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <v-icon @click="editDocument(item)">

              mdi-pencil
            </v-icon>
          </template>
          <template v-slot:[`item.isactive`]="{ item }">
            <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
              @change="toggledocuments(item)"></v-switch>
          </template>
          <template v-slot:[`item.description`]="{ item }">
            <v-btn color="success" icon dark @click="getDescription(item)" title="Description">
              <v-icon> mdi-book-open</v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.assign`]="{ item }">
            <v-btn color="#ff9800" icon dark @click="getassign(item)" title="Assign">
              <v-icon> mdi-arrow-right-bold-box</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <!-- Password Dialog -->
        <!-- <v-dialog v-model="passwordDialog" max-width="400" persistent>
          <v-card>
            <v-card-title>Password</v-card-title>
            <v-card-text>
              <v-text-field v-model="password" :type="showPassword ? 'text' : 'password'" label="Enter Password"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="showPassword = !showPassword"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="validatePassword">Submit</v-btn>
              <v-btn color="red darken-1" text @click="passwordDialog = false">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
      </v-card>
      <v-dialog v-model="description_dialog" max-width="1200px" persistent>
        <v-card>
          <br>
          <!-- <v-card-text>
            {{ show_description.description }}
          </v-card-text> -->
          <v-card-text>
            <v-row>
              <v-col style="font-weight: bold;" sm="12" md="4">Document Category : {{ show_description.documentcategory
                }}</v-col>

              <v-col style="font-weight: bold;" sm="12" md="4">Document Sub Category : {{
                show_description.documentsubcategory
                }}
              </v-col>
              <!-- <v-col style="font-weight: bold;" sm="12" md="4">Name : {{ show_description.name
                }}</v-col>
              <v-col style="font-weight: bold;" sm="12" md="4">Reference Number : {{ show_description.reference_number
                }}</v-col> -->
              <v-col style="font-weight: bold;" sm="12" md="4">Academic Year : {{ show_description.academicyear
                }}</v-col>
            </v-row>
            <v-row>
              <v-col style="font-weight: bold;" sm="12" md="4">Password : {{ show_description.opening_password
                }}</v-col>
              <v-col style="font-weight: bold;" sm="12" md="4">Keywords : {{ show_description.keywords
                }}</v-col>
              <v-col style="font-weight: bold;" sm="12" md="4">Owner : {{ show_description.entryby
                }}</v-col>
            </v-row>
            <v-row>
              <v-col style="font-weight: bold;" sm="12" md="4">Assigned To : {{ show_description.assignedto
                }}</v-col>
              <v-col style="font-weight: bold;" sm="12" md="4">Vendor : {{ show_description.vendor
                }}</v-col>
              <v-col style="font-weight: bold;" sm="12" md="4">Document Level : {{
                show_description.documentlevel
                }}</v-col>

            </v-row>
            <v-row>
              <v-col style="font-weight: bold;" sm="12" md="4">Reference Number : {{ show_description.reference_number
                }}</v-col>
              <v-col style="font-weight: bold;" sm="12" md="4">Assigned Person Email : {{
                show_description.assigned_person_email
                }}</v-col>


              <v-col style="font-weight: bold;" sm="12" md="4">Assigned Person Contact : {{
                show_description.assigned_person_contact
                }}</v-col>

            </v-row>
            <v-row>
              <v-col style="font-weight: bold;" sm="12" md="4">Target Person Name : {{
                show_description.target_person_name
                }}</v-col>
              <v-col style="font-weight: bold;" sm="12" md="4"></v-col>


              <v-col style="font-weight: bold;" sm="12" md="4"></v-col>

            </v-row>

          </v-card-text>
          <v-card-actions class="justify-center"><v-btn color="warning"
              @click="description_dialog = false">Close</v-btn></v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="assign_dialog" max-width="1200px" fullscreen>
        <v-card>
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <strong> Assign</strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn fab small color="white" outlined icon @click="assign_dialog = false"><v-icon> mdi-close
              </v-icon></v-btn>
          </v-toolbar>
          <br />
          <!-- {{ show_assign }} -->
          <v-card class="box">
            <v-toolbar flat dense class="toolbar">
              <v-toolbar-title>Add Document</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
            <br>

            <v-row justify="center">
              <v-col cols="12" sm="4">
                <v-autocomplete color="#0F2027" dense rounded required v-model="assigned_to_edit"
                  :items="instructor_list" item-value="id" item-text="name" label="Please Select Instructor" outlined
                  persistent-hint hint="Please Select Instructor" multiple />
              </v-col>
              <v-col cols="12" sm="4">
                <v-autocomplete color="#0F2027" dense rounded required v-model="access_control"
                  :items="access_control_list" item-value="id" item-text="name" label="Select Access Control" outlined
                  persistent-hint hint="Please Select Access Control" multiple />
              </v-col>
              <v-col cols="12" sm="2" v-if="assigned_to_edit.length > 0 && access_control">
                <v-btn class="button" @click="assignAccess()">Assign</v-btn>

              </v-col>
            </v-row>
          </v-card>


          <v-card class="box">
            <v-data-table :headers="headers_2" :items="document_access_control_list" sort-by="standard"
              class="elevation-1 mytable" dense :search="search" :items-per-page="-1">
              <template v-slot:top>
                <v-toolbar dense class="toolbar" flat color="white">
                  <v-toolbar-title>Document Access Control</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                </v-toolbar>

                <span style="width: 20px;"> </span>
                <v-row justify="center" dense>
                  <v-col sm="3" md="8" cols="12"> </v-col>
                  <v-col sm="6" md="6" cols="12">
                    <v-text-field v-model="search" append-icon="search" label="Search" single-line
                      hide-details></v-text-field>
                  </v-col>
                  <span style="width: 20px;"></span>

                </v-row>
              </template>
              <template v-slot:[`item.isactive`]="{ item }">
                <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                  @change="toggle(item)"></v-switch>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-icon color="red" @click="deleteDocumentAccess(item.id)">mdi-trash-can</v-icon>
              </template>

            </v-data-table>
          </v-card>
        </v-card>
      </v-dialog>
      <v-dialog v-model="show_documents_edit_card" fullscreen transition="dialog-bottom-transition">
        <v-card class="box">
          <v-toolbar flat class="toolbar">
            <v-toolbar-title> Edit Document
            </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn fab small color="white" outlined icon @click="show_documents_edit_card = false"><v-icon>
                mdi-close
              </v-icon></v-btn>
          </v-toolbar>
          <br>


          <v-row justify="center">

            <v-col cols="12" sm="4">
              <v-autocomplete color="#0F2027" dense rounded required v-model="edited_document_Item.document_category"
                item-value="category_id" :items="document_category_list" item-text="category_name"
                label="Select Document Category" outlined persistent-hint hint="Please Select Document Category"
                @change="get_document_sub_category_in_edit()" />
            </v-col>
            <!-- @change="get_document_sub_category()" -->
            <v-col cols="12" sm="4" v-if="!isOfficeOrder">
              <v-autocomplete color="#0F2027" dense rounded required
                v-model="edited_document_Item.document_sub_category" item-value="id"
                :items="document_sub_cateogy_list_inedit" item-text="name" label="Select Document Sub Category" outlined
                persistent-hint hint="Please Select Document Sub Category" />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" sm="4">

              <v-text-field rounded outlined dense type="text" label="Document Name"
                v-model="edited_document_Item.doc_name" width="50"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" justify="center" align="center">
              <v-text-field rounded outlined dense type="text" label="Document Reference Number"
                v-model="edited_document_Item.reference_number"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-autocomplete color="#0F2027" dense rounded required v-model="edited_document_Item.ay" :items="ay_list"
                item-value="id" item-text="ay" label="Select AY" outlined persistent-hint hint="Please Select AY" />
            </v-col>

          </v-row>
          <v-row justify="center" class="pa-40">
            <v-col cols="12" sm="4">
              <v-text-field label="Validity From Date(inclusive)" rounded outlined dense type="date"
                v-model="edited_document_Item.validity_fromdate"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field label="Validity To Date(Exclusive)" rounded outlined dense type="date"
                v-model="edited_document_Item.validity_todate"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field label="Issue Date" rounded outlined dense type="date"
                v-model="edited_document_Item.issue_date"></v-text-field>
            </v-col>

          </v-row>
          <v-row justify="center" class="pa-40">

            <v-col cols="12" sm="4" md="4">

              <v-file-input prepend-icon="mdi-paperclip" label="Attachment" show-size flat rounded outlined dense
                v-model="edited_document_Item.doc_file"></v-file-input>
              <span v-if="edited_document_Item.attachment != null">
                Previous File : <a target="_blank" :href="basepath + edited_document_Item.attachment">View</a>
              </span>


            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field rounded outlined dense :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
                label="File Opening Password(If Any)" v-model="edited_document_Item.opening_password"
                @click:append="() => (value = !value)" :type="value ? 'password' : 'text'"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field rounded outlined dense type="text" label="Keywords To Search File"
                v-model="edited_document_Item.keywords"></v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center" class="pa-40" v-if="!isOfficeOrder">

            <v-col cols=" 12" sm="4">
              <v-autocomplete color="#0F2027" dense rounded required v-model="edited_document_Item.assigned_to"
                :items="instructor_list" item-value="id" item-text="name" return-object label="Assigned To" outlined
                persistent-hint hint="Please Assigned To" @change="setvaluesedit(edited_document_Item.assigned_to)" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-autocomplete color="#0F2027" dense rounded required v-model="edited_document_Item.vendor"
                :items="vendor_list" item-value="id" item-text="company_name" label="Select Vendor" outlined
                persistent-hint hint="Please Select Vendor" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field rounded outlined dense type="text" label="Target Person"
                v-model="edited_document_Item.target_person_name"></v-text-field>
            </v-col>

          </v-row>
          <v-row class="pa-40">

            <v-col cols="12" sm="4">
              <v-autocomplete color="#0F2027" dense rounded required v-model="edited_document_Item.document_level"
                :items="document_level_list" item-value="id" item-text="name" label="Document Level" outlined
                persistent-hint hint="Document Level" />
            </v-col>

            <v-col cols="12" sm="4" v-if="isOfficeOrder">
              <v-autocomplete color="#0F2027" dense rounded required v-model="edited_document_Item.instructor"
                :items="instructor_list" item-value="id" item-text="name" return-object label="Please Select Instructor"
                outlined persistent-hint hint="Please Select Instructor" />
            </v-col>
            <v-col cols="12" sm="4" v-if="edited_document_Item.assigned_to && !isOfficeOrder">
              <v-text-field rounded outlined dense type="text" label="Assigned Person Email"
                v-model="edited_document_Item.assigned_person_email"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" v-if="edited_document_Item.assigned_to && !isOfficeOrder">
              <v-text-field rounded outlined dense type=" text" label="Assigned Person Contact"
                v-model="edited_document_Item.assigned_person_contact"></v-text-field>
            </v-col>

          </v-row>
          <v-row class="pa-40">



          </v-row>
          <v-row justify="center">
            <v-col cols="12" sm="4">
              <v-textarea outlined name="input-7-4" v-model="edited_document_Item.description"
                label="Enter Description"></v-textarea>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-btn class="button" :loading="loader" @click="EditDocument" dense>Edit</v-btn>
          </v-row>
          <br>
        </v-card>



      </v-dialog>
    </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    officeOrderCategoryName: 'Office Order',
    loader: false,
    snackbar_msg: "",
    extraBreadcrumbItems: [

    ],
    breadcrumbClass: "breadcrumb-style1",
    color: "",
    description_dialog: false,

    assign_dialog: false,
    show_description: "",
    show_assign: "",
    // passwordDialog: false,
    // password: '',
    //showPassword: false,
    currentAttachment: null,
    snackbar: false,
    overlay: false,
    show_documents_edit_card: false,
    reference_number: "",
    doc_name: "",
    description: "",
    instructor_list: [], assigned_to: "", assigned_to_edit: [],
    assigned_person_email: "",
    assigned_person_contact: "",
    vendor_list: [],
    instructor: "",
    documentcategory: "",
    document_sub_category_list: [],
    document_category_list: [],
    document_sub_cateogy_list_inedit: [],
    vendor: "",
    document_category: "",
    document_sub_category: "",
    document_level_list: [], document_level: "",
    issue_date: new Date().toISOString().slice(0, 10),
    //fromdate: new Date().toISOString().slice(0, 10),
    //todate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toISOString().substr(0, 10),
    ay_list: [], ay: "",fromdate:"",todate:"",
    doc_file: null, opening_password: "", keywords: "", target_person_name: "",
    value: String,
    headers: [
      { text: "Srno", value: "srno" },
      { text: "Document", value: "attachment" },
      { text: "Name", value: "name" },
      // { text: "Reference Number", value: "reference_number" },
      { text: "Valid From", value: "validity_start_date" },
      { text: "Valid Till", value: "validity_end_date" },
      { text: "Upload Date", value: "upload_date" },
      { text: "Issue Date", value: "issue_date" },
      { text: "Status", value: "isactive" },
      { text: "Description", value: "description" },
      // { text: "AY", value: "academicyear" },
      // { text: "Password", value: "opening_password" },
      // { text: "Keywords", value: "keywords" },
      // { text: "Password", value: "opening_password" },

      // { text: "Owner", value: "entryby" },
      // { text: "Assigned To", value: "assignedto" },
      // { text: "Assigned Person Email", value: "assigned_person_email" },
      // { text: "Assigned Person Contact", value: "assigned_person_contact" },
      // { text: "Vendor", value: "vendor" },
      // { text: "Document Level", value: "documentlevel" },
      { text: "Assign", value: "assign" },
      { text: "Edit", value: "edit" },
      { text: "Delete", value: "action" },
    ],
    documents_list: [], basepath: null,
    edited_document_Item: {
      id: "",
      doc_name: "",
      reference_number: "",
      ay: "",
      validity_fromdate: "",
      validity_todate: "",
      assigned_to: "",
      attachment: "",

      opening_password: "",
      instructor: "",
      issue_date: "",
      keywords: "",
      vendor: "",
      document_category: "",
      document_sub_category: "",
      document_level: "",
      target_person_name: "",
      assigned_person_email: "",
      assigned_person_contact: "",
      description: "",
    },
    headers_2: [
      {
        text: "Document",
        value: "document_name",
      },
      {
        text: "Document Access For",
        value: "documentAccessControlMaster_name",
      },

      {
        text: "Assigned To",
        value: "assignedto_name",
      },
      {
        text: "Assigned By",
        value: "assignedby_name",
      },
      {
        text: "Assignment Date",
        value: "assignment_date_show",
      },

      {
        text: "Active",
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    document_access_control_list: [], access_control_list: [], access_control: "", document_id: "", search: ""
  }),
  computed: {
    isOfficeOrder() {
      const category = this.document_category_list.find(
        item => item.category_id === this.edited_document_Item.document_category
      );
      return category && category.category_name === this.officeOrderCategoryName;
    }
  },
  methods: {
    get_document_sub_category() {
      this.instructor = "";
      this.vendor = "";
      this.document_sub_category = "";
      this.assigned_person_contact = "";
      this.assigned_person_email = "";
      this.document_sub_category_list = this.document_category.div_list;

    },
    get_document_sub_category_in_edit() {
      this.edited_document_Item.document_sub_category = "";
      const data = {
        id: this.edited_document_Item.document_category

      };
      this.overlay = true;
      axios.post("/AMC/getdocumentsubcategory", data)
        .then(res => {
          this.overlay = false;
          if (res.data.flag == "YES") {
            this.document_sub_cateogy_list_inedit = res.data.document_sub_category_list;

          } else {

            this.showSnackbar("red", res.data.Message);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch(error => {
          this.overlay = false; // Hide overlay if there's an error
          console.error(error);
        });
    },
    onLoad() {
      this.overlay = true;
      axios.post("/AMC/getOwnerDocuments")
        .then(res => {
          this.overlay = false;
          if (res.data.flag == "YES") {

            this.ay_list = res.data.ay_list;
            this.ay = res.data.current_ay;
            this.instructor_list = res.data.instructor_list;
            this.vendor_list = res.data.vendor_list;
            this.document_level_list = res.data.document_level_list;
            this.document_level = this.document_level_list[0].id;
            this.documents_list = res.data.documents_list;
            this.document_category_list = res.data.data;
            this.document_sub_cateogy_list_inedit = res.data.document_sub_cateogy_list;

          } else {

            this.showSnackbar("red", res.data.Message);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch(error => {
          this.overlay = false; // Hide overlay if there's an error
          console.error(error);
        });
    },

    setvaluesedit(inst) {
      this.edited_document_Item.assigned_person_email = inst.inst_email
      this.edited_document_Item.assigned_person_contact = inst.inst_contact
    },

    async EditDocument() {

      let assignedToId = this.edited_document_Item.assigned_to ? this.edited_document_Item.assigned_to.id : this.edited_document_Item.assigned_to; // Handle assigned_to correctly
      let instructorId = this.edited_document_Item.instructor ? this.edited_document_Item.instructor.id : this.edited_document_Item.instructor; // Handle assigned_to correctly
      let formData = new FormData();
      formData.append("id", this.edited_document_Item.id);
      formData.append("doc_file", this.edited_document_Item.doc_file);
      formData.append("description", this.edited_document_Item.description);
      formData.append("reference_number", this.edited_document_Item.reference_number);
      formData.append("doc_name", this.edited_document_Item.doc_name);
      formData.append("ay", this.edited_document_Item.ay);
      formData.append("vendor", this.edited_document_Item.vendor);
      formData.append("document_level", this.edited_document_Item.document_level);
      formData.append("issue_date", this.edited_document_Item.issue_date);
      formData.append("fromdate", this.edited_document_Item.validity_fromdate);
      formData.append("todate", this.edited_document_Item.validity_todate);
      formData.append("assigned_to", assignedToId);
      formData.append("assigned_person_email", this.edited_document_Item.assigned_person_email);
      formData.append("assigned_person_contact", this.edited_document_Item.assigned_person_contact);
      formData.append("opening_password", this.edited_document_Item.opening_password);
      formData.append("keywords", this.edited_document_Item.keywords);
      formData.append("target_person_name", this.edited_document_Item.target_person_name);
      formData.append("document_category", this.edited_document_Item.document_category);
      formData.append("document_sub_category", this.edited_document_Item.document_sub_category);
      formData.append("instructor", instructorId);
      this.overlay = true;
      this.loader = true;
      try {
        const res = await axios.post("/AMC/updateDocumentAccess", formData)
        if (res.data.status == "200") {
          this.showSnackbar("green", "Update Successfully...");
          this.onLoad();
          this.show_documents_edit_card = false;
        } else {
          this.showSnackbar("red", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
        }
        this.overlay = false;
        this.loader = false;
      }
      catch (err) {
        this.onerror(err);
        this.overlay = false;
      }
      finally {
        this.overlay = false;
        this.loader = false;
      }
    },
    editDocument(item) {

      this.edited_document_Item.id = item.id;
      this.edited_document_Item.doc_name = item.name;
      this.edited_document_Item.reference_number = item.reference_number;
      this.edited_document_Item.ay = item.academicyear_id;
      this.edited_document_Item.validity_fromdate = this.formatDate(item.validity_start_date);
      this.edited_document_Item.validity_todate = this.formatDate(item.validity_end_date);
      this.edited_document_Item.assigned_to = item.assignedto_id ? { id: item.assignedto_id, name: item.assignedto_name } : null; // Ensure assigned_to is correctly set
      this.edited_document_Item.attachment = item.attachment;
      this.edited_document_Item.opening_password = item.opening_password;
      this.edited_document_Item.issue_date = this.formatDate(item.issue_date);;
      this.edited_document_Item.keywords = item.keywords;
      this.edited_document_Item.vendor = item.vendor_id;
      this.edited_document_Item.document_sub_category = item.documentsubcategory_id;
      this.edited_document_Item.document_category = item.documentcategory_id;
      this.edited_document_Item.document_level = item.documentlevel_id;
      this.edited_document_Item.target_person_name = item.target_person_name;
      this.edited_document_Item.assigned_person_email = item.assigned_person_email;
      this.edited_document_Item.assigned_person_contact = item.assigned_person_contact;
      this.edited_document_Item.description = item.description;
      this.edited_document_Item.instructor = item.instructor_id ? { id: item.instructor_id, name: item.instructor } : null;
      this.document_sub_cateogy_list_inedit = this.document_sub_cateogy_list_inedit;
      this.documentcategory = item.documentcategory;
      this.show_documents_edit_card = true;
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      let month = '' + (d.getMonth() + 1);
      let day = '' + d.getDate();
      const year = d.getFullYear();
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [year, month, day].join('-');
    },
    assignAccess() {
      const formData = {
        document_id: this.document_id,
        instructors: this.assigned_to_edit,
        access_control: this.access_control

      };
      this.overlay = true;
      axios
        .post("/AMC/assignDocumentAccess", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", "Assigned Successfully..");
            this.document_access_control_list = res.data.document_access_control_list

          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.assigned_to_edit = [];
          this.access_control = ""
          this.assign_dialog = true;
        });
    },
    deleteDocumentAccess(item) {
      if (!confirm("Are You Sure You Want To Remove Access...?")) return;
      const data = {
        doc_access_id: item,
      };
      this.overlay = true;
      axios
        .post("/AMC/deleteDocumentAccess", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "Document Access Deleted Successfully..!"); // show snackbar
            this.document_access_control_list = res.data.document_access_control_list
          } else
            this.showSnackbar("#4caf50", "Something went wrong, Please try again later!"); // show snackbar
          sessionStorage.setItem("error-trace", res.data.error_trace);
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    toggle(item) {
      const data = {
        section_id: item.id,
        toggle: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/AMC/toggleDocumentAccessControl", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "Document Access Control Status Changed!"); // show snackbar
            this.document_access_control_list = res.data.document_access_control_list
          } else
            this.showSnackbar("#4caf50", "Something went wrong, Please try again later!"); // show snackbar
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    toggledocuments(item) {
      const data = {
        section_id: item.id,
        toggle: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/AMC/toggleDocument", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "Document Status Changed!"); // show snackbar
            this.onLoad();
          } else
            this.showSnackbar("#4caf50", "Something went wrong, Please try again later!"); // show snackbar
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getDescription(item) {
      this.show_description = item;
      this.description_dialog = true;
    },
    getassign(item) {
      this.document_id = item.id
      const formData = {
        doc_id: item.id,
      };
      this.overlay = true;
      axios
        .post("/AMC/getAccessControlListForDocument", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            // this.showSnackbar("green", "Deleted Successfully..");
            this.document_access_control_list = res.data.document_access_control_list
            this.access_control_list = res.data.access_control_list
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.show_assign = item;
          this.assign_dialog = true;
        });
    },
    deleteDocument(item) {
      if (!confirm("Are You Sure You Want To Delete...?")) return;
      const formData = {
        doc_id: item,
      };
      this.overlay = true;
      axios
        .post("/AMC/deleteDocument", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", "Deleted Successfully..");
            this.documents_list = res.data.documents_list
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    setvalues(inst) {

      this.assigned_person_email = inst.inst_email
      this.assigned_person_contact = inst.inst_contact
    },
    setNullValues() {
      this.doc_name = "",
        this.reference_number = "",
        this.description = "",
        this.assigned_to = "",
        this.assigned_person_email = "",
        this.assigned_person_contact = "",
        this.vendor = "",
        this.document_category = "",
        this.document_sub_category = "",
        this.ay = "",
        //  this.doc_file = "",
        this.opening_password = "",
        this.keywords = "",
        this.instructor = "",
        this.target_person_name = ""
    },
    async addDocument() {
      let formData = new FormData();
      if (this.doc_file == '' || this.doc_file == null) {
        this.showSnackbar("red", "Please select Document File...");
        return;
      }
      if (this.doc_name == '' || this.doc_name == null) {
        this.showSnackbar("red", "Please enter Document Name...");
        return;
      }
      formData.append("doc_file", this.doc_file);
      formData.append("description", this.description);
      formData.append("reference_number", this.reference_number);
      formData.append("doc_name", this.doc_name);
      formData.append("ay", this.ay);
      formData.append("vendor", this.vendor);
      formData.append("document_level", this.document_level);
      formData.append("document_category", this.document_category.category_id);
      formData.append("document_sub_category", this.document_sub_category.subcat_id);
      formData.append("issue_date", this.issue_date);
      formData.append("fromdate", this.fromdate);
      formData.append("todate", this.todate);
      formData.append("assigned_to", this.assigned_to.id);
      formData.append("instructor", this.instructor.id);
      formData.append("assigned_person_email", this.assigned_person_email);
      formData.append("assigned_person_contact", this.assigned_person_contact);
      formData.append("opening_password", this.opening_password);
      formData.append("keywords", this.keywords);
      formData.append("target_person_name", this.target_person_name);
      this.overlay = true;
      this.loader = true;
      try {
        const res = await axios.post("/AMC/addDocument", formData)
        if (res.data.flag == "YES") {
          this.showSnackbar("green", "Saved Successfully...");
          this.documents_list = res.data.documents_list
          this.setNullValues();
        } else {
          this.showSnackbar("red", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
        }
        this.overlay = false;
        this.loader = false;
      }
      catch (err) {
        this.onerror(err);
        this.overlay = false;
      }
      finally {
        this.overlay = false;
        this.loader = false;
      }
    },


    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
    this.basepath = localStorage.getItem("awspath");
  },
  watch: {},
};
</script>
<style scoped></style>